import { Button, Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import sampleResponses from "static-data/sample-responses";
import MDButton from "components/MDButton";
import { ContentCopy } from "@mui/icons-material";
import Subscribe from "../assets/account_balance_subscribe.svg";
import SubscribeLight from "../assets/account_balance_subscribe_light.svg";
import { useMaterialUIController } from "context";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WebSocketSingle from "../code/web-socket-singleir";
import WebSocketHub from "../code/web-socket-hub-smaple-code";
import WebSocketSingleDark from "../code/web-socket-singleir-dark";
import WebSocketHubDark from "../code/web-socket-hub-smaple-code-dark";
import useCopyToClipboard from "custom-hooks/useCopyToClipboard";
import StepOne from "../assets/stepone.png";
import StepTwo from "../assets/steptwo.png";
import StepThree from "../assets/stepthree.png";
import StepFourA from "../assets/stepfive.png";
import PropTypes from "prop-types";

const ApiDescription = ({ data, search }) => {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();

  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      } else {
        return (
          childVal?.parentHeading?.toLowerCase()?.includes(search) ||
          childVal?.mainHeading?.toLowerCase()?.includes(search) ||
          childVal?.mainHeadingStatic?.toLowerCase()?.includes(search) ||
          childVal?.mainHeadingDesc?.toLowerCase()?.includes(search)
        );
      }
    });
  };
  const filtered = filter();
  const themeMode = darkMode ? "dark-tbl" : "light-tbl";

  const getBadgeClassName = (method) => {
    if (method === "GET") return "post-badge get";
    if (method === "PUT") return "post-badge put";
    if (method === "DELETE") return "post-badge delete";
    if (method === "PATCH") return "post-badge patch";
    return "post-badge";
  };
  return (
    <>
      {filtered.length === 0 ? (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      ) : (
        filtered.map((childVal) => (
          <Grid
            container
            xs={12}
            mt={4}
            key={childVal.mainGridId}
            id={childVal.mainGridId}
          >
            <Grid item xs={12} md={childVal.staticData ? "12" : "8"} pr={2}>
              <MDBox>
                {childVal.mainHeading && (
                  <MDTypography
                    variant="h4"
                    fontWeight="medium"
                    fontFamily="inherit"
                    lineHeight={3}
                    mt={0}
                  >
                    {childVal.mainHeading}
                  </MDTypography>
                )}
                {childVal?.staticDataTwo && (
                  <>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal?.generalDescWithLinkOne.desc}
                    </MDTypography>
                    <p className="doc-text" style={{ marginLeft: "10px" }}>
                      {childVal?.generalDescWithLinkOne.link}
                      <Button
                        variant="text"
                        className="copyiconparent"
                        onClick={() =>
                          copy(childVal?.generalDescWithLinkOne.link)
                        }
                      >
                        <ContentCopyIcon className="copyicon" />
                      </Button>
                    </p>
                    <br />
                  </>
                )}
                {childVal?.staticDataTwo && (
                  <MDTypography
                    variant="p"
                    fontSize="14px"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={2}
                  >
                    {childVal?.textOne}{" "}
                    <p className="staus-code">{childVal?.textTwo}</p>
                    {". "}
                    {childVal?.textThree}
                  </MDTypography>
                )}

                {childVal.mainHeadingDesc && (
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDesc}
                    </MDTypography>
                    {childVal?.supportEmail && (
                      <a
                        className="support-email"
                        href={"mailto:" + childVal?.supportEmail}
                      >
                        {childVal?.supportEmail}
                      </a>
                    )}
                  </p>
                )}
                {childVal.mainHeadingDesc2 && (
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDesc2}
                    </MDTypography>
                  </p>
                )}
                {childVal.subHeading && (
                  <MDTypography
                    variant="h5"
                    fontWeight="medium"
                    fontFamily="inherit"
                    lineHeight={3}
                    mt={2}
                  >
                    {childVal.subHeading}
                  </MDTypography>
                )}
                {childVal.subHeadingDesc && (
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.subHeadingDesc}
                    </MDTypography>
                  </p>
                )}
                {childVal.subHeadingDesc2 && (
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.subHeadingDesc2}
                    </MDTypography>
                  </p>
                )}
                {childVal.staticData && (
                  <>
                    {childVal.imgIndex === 0 && (
                      <img src={StepOne} alt={childVal.imgIndex} />
                    )}
                    {childVal.imgIndex === 1 && (
                      <img src={StepTwo} alt={childVal.imgIndex} />
                    )}
                    {childVal.imgIndex === 2 && (
                      <img src={StepThree} alt={childVal.imgIndex} />
                    )}
                    {childVal.imgIndex === 3 && (
                      <img src={StepFourA} alt={childVal.imgIndex} />
                    )}
                  </>
                )}
              </MDBox>
              {childVal.subHeadingImg && (
                <MDBox>
                  <img
                    src={darkMode ? Subscribe : SubscribeLight}
                    className="subimg"
                    alt={darkMode ? Subscribe : SubscribeLight}
                  />
                  <br />
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.subHeadingImgDesc}
                    </MDTypography>
                  </p>
                </MDBox>
              )}
              {childVal.endPointHeading && (
                <MDBox mt={3}>
                  <MDTypography
                    variant="h5"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={2}
                    id={childVal.endPointId ? childVal.endPointId : ""}
                  >
                    {childVal.endPointHeading}
                  </MDTypography>
                  <MDTypography
                    variant="h6"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={1}
                    className={getBadgeClassName(childVal.endPointMethod)}
                  >
                    {childVal.endPointMethod}
                  </MDTypography>
                  <MDTypography
                    variant="h6"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={1}
                    className="link-badge"
                  >
                    {childVal.endPointDesc}
                    <MDButton
                      variant="text"
                      className="copyiconparent"
                      onClick={() => copy(childVal.endPointDesc)}
                    >
                      <ContentCopy className="copyicon" />
                    </MDButton>
                  </MDTypography>
                  <br />
                </MDBox>
              )}
              {childVal.requestParams && (
                <MDBox mt={3}>
                  <MDTypography
                    variant="h5"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={2}
                    id={childVal.requestParamsId}
                  >
                    {childVal.requestParams}
                  </MDTypography>
                  <MDBox mt={3} className="trade-req table-doc">
                    <Card>
                      <MDBox className={themeMode}>
                        <DataTable
                          table={{
                            columns: childVal.requestParamsTable.columns,
                            rows: childVal.requestParamsTable.rows,
                          }}
                          isSorted={false}
                          entriesPerPage={{
                            defaultValue: 1000,
                          }}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </Card>
                  </MDBox>
                </MDBox>
              )}
              <MDBox mt={3}>
                {childVal.requestHeader && (
                  <>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      id={childVal.requestHeaderId}
                    >
                      {childVal.requestHeader}
                    </MDTypography>
                    <MDBox mt={3} className="trade-head table-doc">
                      <Card>
                        <MDBox className={themeMode}>
                          <DataTable
                            table={{
                              columns: childVal.requestHeaderTableData.columns,
                              rows: childVal.requestHeaderTableData.rows,
                            }}
                            isSorted={false}
                            entriesPerPage={{
                              defaultValue: 1000,
                            }}
                            showTotalEntries
                            noEndBorder
                          />
                        </MDBox>
                      </Card>
                    </MDBox>
                    {childVal.requestHeaderNote && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.requestHeaderNote}
                        </MDTypography>
                      </p>
                    )}
                  </>
                )}
              </MDBox>
              <MDBox mt={3}>
                {childVal.requestBodyTable && (
                  <>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      id={childVal.requestBodyId}
                    >
                      {childVal.requestBody}
                    </MDTypography>
                    <MDBox mt={3} className="trade-req table-doc">
                      <Card>
                        <MDBox className={themeMode}>
                          <DataTable
                            table={{
                              columns: childVal.requestBodyTable.columns,
                              rows: childVal.requestBodyTable.rows,
                            }}
                            isSorted={false}
                            entriesPerPage={{
                              defaultValue: 1000,
                            }}
                            showTotalEntries
                            noEndBorder
                          />
                        </MDBox>
                      </Card>
                    </MDBox>
                  </>
                )}
              </MDBox>
              {childVal.respBody && (
                <MDBox mt={3}>
                  <MDTypography
                    variant="h5"
                    fontWeight="regular"
                    fontFamily="inherit"
                    lineHeight={2}
                    id={childVal.respBodyId}
                  >
                    {childVal.respBody}
                  </MDTypography>
                  {childVal?.respBodySuccessStatusCode && (
                    <p className="staus-code code-success">
                      {childVal?.respBodySuccessStatusCode}
                    </p>
                  )}
                  {childVal.respBodySuccessDesc && (
                    <p>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.respBodySuccessDesc}
                      </MDTypography>
                    </p>
                  )}
                  {childVal.respBodyTable && (
                    <MDBox mt={3} className="trade-resp table-doc">
                      <Card>
                        <MDBox className={themeMode}>
                          <DataTable
                            table={{
                              columns: childVal.respBodyTable.columns,
                              rows: childVal.respBodyTable.rows,
                            }}
                            isSorted={false}
                            entriesPerPage={{
                              defaultValue: 1000,
                            }}
                            showTotalEntries
                            noEndBorder
                          />
                        </MDBox>
                      </Card>
                    </MDBox>
                  )}
                </MDBox>
              )}
            </Grid>
            {childVal?.SampleCode && (
              <Grid item xs={12} md={12} pr={2}>
                <MDBox>
                  <p>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      id={childVal.SampleCodeId}
                    >
                      {childVal.SampleCodeTitle}
                    </MDTypography>
                  </p>
                  {childVal?.index === 0 && (
                    <>{darkMode ? <WebSocketHubDark /> : <WebSocketHub />}</>
                  )}
                  {childVal?.index === 1 && (
                    <>
                      {darkMode ? <WebSocketSingleDark /> : <WebSocketSingle />}
                    </>
                  )}
                </MDBox>
              </Grid>
            )}
            {childVal.respBody && (
              <Grid item xs={12} md={8} pr={2}>
                <MDBox>
                  {childVal.respBodyAcceptedCode && (
                    <p
                      className="staus-code accepted mt-3"
                      id={childVal.respBodyAcceptedCodeId}
                    >
                      {childVal.respBodyAcceptedCode}
                    </p>
                  )}
                  {childVal.respBodyAcceptedDesc && (
                    <p>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.respBodyAcceptedDesc}
                      </MDTypography>
                    </p>
                  )}
                  {!childVal.respBodyErrorTable
                    ? childVal.respBodyErrorDesc && (
                        <p className="staus-code code-red mt-3">
                          {childVal.respBodyErrorStatusCode}
                        </p>
                      )
                    : ""}
                  {!childVal.respBodyErrorTable
                    ? childVal.respBodyErrorDesc && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal.respBodyErrorDesc}
                          </MDTypography>
                        </p>
                      )
                    : ""}
                </MDBox>
              </Grid>
            )}
            {childVal.respObjKey && (
              <Grid item xs={12} md={4}>
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  id={childVal.respObjId}
                >
                  Response Object
                </MDTypography>
                <HighlightedCode
                  code={sampleResponses.trading[childVal.respObjKey].trim()}
                />
              </Grid>
            )}
            {childVal.noContentCode && (
              <Grid item xs={12} md={8} pr={2} id={childVal.noContentId}>
                <MDBox>
                  <p className="staus-code no-content">
                    {childVal.noContentCode}
                  </p>
                  <p>
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.noContentDesc}
                    </MDTypography>
                  </p>
                </MDBox>
              </Grid>
            )}

            {childVal.respBodyErrorTable && (
              <Grid item xs={12} md={8} pr={2} id={childVal.respBodyErrorId}>
                <MDBox mt={3}>
                  <p className="staus-code code-red">
                    {childVal.respBodyErrorStatusCode}
                  </p>
                  {childVal.respBodyErrorDesc && (
                    <p>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.respBodyErrorDesc}
                      </MDTypography>
                    </p>
                  )}
                  <MDBox className="trade-resp-err table-doc">
                    <Card>
                      <MDBox className={themeMode}>
                        <DataTable
                          table={{
                            columns: childVal.respBodyErrorTable.columns,
                            rows: childVal.respBodyErrorTable.rows,
                          }}
                          isSorted={false}
                          entriesPerPage={{
                            defaultValue: 1000,
                          }}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </Card>
                  </MDBox>
                </MDBox>
              </Grid>
            )}
          </Grid>
        ))
      )}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
